import { z } from 'zod';

import { PidReasonEnumV12 } from '../../api/generated/cz.partners.pid.backofficegateway.pid.external';

const { OTHER, ...reasonsWithoutOther } = PidReasonEnumV12;

export const viewClientReasonSchema = z.union([
	z.object({
		reason: z.literal(PidReasonEnumV12.OTHER),
		additionalReason: z.string().min(1),
	}),
	z.object({
		reason: z.enum(reasonsWithoutOther),
	}),
]);

export type ViewClientReason = z.infer<typeof viewClientReasonSchema>;
